<template>
  <div class="row folder">
    <div class="header flex items-center justify-between">
      <h1 class="title">{{ folder.name }}</h1>
      <div class="flex items-center justify-between">
        <visible class="flex items-center justify-center" :when="isOwner">
          <ts-button type="normal" class="mx-2" size="small" filled @click.prevent="handleCreateProjectClick">
            Create new project
          </ts-button>
          <edit-folder :folder="folder" />
          <ts-button size="small" circle class="mx-2" @click="archive">
            <ts-icon icon="trash" size="x-small" title="Archive" color="#6d7587" />
          </ts-button>
        </visible>
        <div class="ml-4">
          <button class="expandable-button" @click.prevent="expanded = !expanded">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" v-if="expanded">
              <defs />
              <g fill="none" fill-rule="evenodd">
                <path d="M.063 25.938h25.875V.063H.063z" />
                <path
                  fill="#6D7587"
                  fill-rule="nonzero"
                  d="M24.926 16.741L13.001 4.816 1.077 16.741l2.287 2.287 9.637-9.638 9.638 9.638z"
                />
              </g>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" v-else>
              <defs />
              <g fill="none" fill-rule="evenodd">
                <path d="M25.938.063H.063v25.875h25.875z" />
                <path
                  fill="#6D7587"
                  fill-rule="nonzero"
                  d="M1.075 9.26L13 21.185 24.924 9.26l-2.287-2.287L13 16.611 3.362 6.973z"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="content" :class="[expanded ? 'px-4 py-4' : 'h-0']">
      <project v-for="project in folder.projects" :key="project.id" :project="project"></project>
    </div>
  </div>
</template>

<script>
import projectViewHelpers from '@/mixins/projectViewHelpers';
import EditFolder from './EditFolder.vue';
import { mapActions } from 'vuex';
import Project from './Project.vue';
export default {
  mixins: [projectViewHelpers],
  name: 'Folder',
  components: { Project, EditFolder },
  props: {
    folder: { type: Object, required: true }
  },
  data() {
    return {
      expanded: false,
      showPreventDialog: true
    };
  },
  mounted() {},
  computed: {
    isOwner() {
      return this.isAdmin || this.currentUser.id === this.folder.user_id;
    }
  },
  methods: {
    ...mapActions('workflow', ['archiveFolder']),
    handleCreateProjectClick() {
      this.$router.push({ name: 'create-project', params: { folder: this.folder } });
    },
    archive() {
      if (this.folder.projects.length > 0) {
        window.EventBus.$emit('folder.archive.prevent', {
          projects: this.folder.projects,
          done: moved => {
            if (moved) {
              this.archiveFolder(this.folder);
            }
          }
        });
        return;
      }
      this.archiveFolder(this.folder);
    }
  }
};
</script>

<style scoped>
.h-0 {
  height: 0;
  overflow: hidden;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.folder {
  flex-direction: column;
  margin: 11px 0 0;
  border-radius: 24px;
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(285deg, #000000, var(--fills-neutral-white) -1%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.mx-2 {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.expandable-button {
  width: 46px;
  height: 46px;
  margin: 0 0 0 20px;
  padding: 10px;
  border-radius: 47px;
  box-shadow: inset 5px 5px 10px 0 #a6abbd, inset -5px -5px 10px 0 #fafbff;
  border: solid 2px rgba(255, 255, 255, 0.4);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(318deg, #000000, var(--fills-neutral-white) -5%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.header {
  width: 100%;
  padding: 10px 10px 11px 30px;
  border-radius: 38px;
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(274deg, #000000, var(--fills-neutral-white) 0%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--fills-neutral-grey-dark);
}
</style>